// Permission Helper - Fonctions utilitaires pour les permissions
import useAuthStore from '../stores/authStore';

export const checkPermission = (module, action = 'read') => {
  const state = useAuthStore.getState();
  const permissions = state.user?.backoffice_permissions || {};

  if (!module) return false;

  const modulePermissions = permissions[module];
  // Vérifier que le tableau existe, n'est pas vide ET est un array
  if (!modulePermissions || !Array.isArray(modulePermissions) || modulePermissions.length === 0) {
    return false;
  }

  if (Array.isArray(action)) {
    return action.every((act) => modulePermissions.includes(act));
  }

  return modulePermissions.includes(action);
};

export const ROUTE_PERMISSION_MAP = {
  '/activite': 'dashboard',
  // catalogue — main + all sub-routes that don't share the /catalogue prefix
  '/catalogue': 'catalogue',
  '/NewProductForm': 'catalogue',
  '/NewCategoryForm': 'catalogue',
  '/NewBrandForm': 'catalogue',
  '/NewRemiseForm': 'catalogue',
  // stock
  '/stock': 'stock',
  // clients
  '/clients': 'clients',
  // loyalty program + cards
  '/fidelite': 'loyalty',
  // pointage (time clock)
  '/pointage': 'attendance',
  // retours & échanges, avoirs
  '/retours': 'returns',
  // other modules
  '/technical-files': 'recipes',
  '/settings': 'settings',
  '/integrations': 'settings',
  '/providers': 'providers',
  '/calander': 'calendar',
  '/reports': 'reports',
};

export const ROUTE_PRIORITY = [
  '/activite',
  '/catalogue',
  '/stock',
  '/clients',
  '/fidelite',
  '/retours',
  '/pointage',
  '/technical-files',
  '/integrations',
  '/providers',
  '/reports',
  '/calander',
  '/settings',
];

// Routes reserved to some business types (selectedAccount.busniessType),
// whatever the user's permissions. 004 = restaurant.
export const ROUTE_BUSINESS_TYPES = {
  '/technical-files': ['004'],
};

export const isRouteAvailableForAccount = (
  pathname,
  account = useAuthStore.getState().selectedAccount
) => {
  const route = Object.keys(ROUTE_BUSINESS_TYPES).find(
    (r) => pathname === r || pathname.startsWith(`${r}/`)
  );
  if (!route) return true;
  return ROUTE_BUSINESS_TYPES[route].includes(account?.busniessType);
};

export const getModuleFromRoute = (pathname) => {
  if (ROUTE_PERMISSION_MAP[pathname]) {
    return ROUTE_PERMISSION_MAP[pathname];
  }

  const matchingRoute = Object.keys(ROUTE_PERMISSION_MAP).find((route) =>
    pathname.startsWith(route)
  );

  return matchingRoute ? ROUTE_PERMISSION_MAP[matchingRoute] : null;
};

export const canAccessRoute = (pathname, account) => {
  if (!isRouteAvailableForAccount(pathname, account)) {
    console.log('[Permission] Route réservée à un autre type de commerce:', pathname);
    return false;
  }

  const module = getModuleFromRoute(pathname);

  console.log('[Permission] Vérification route:', pathname, '→ module:', module);

  if (!module) {
    console.log('[Permission] Pas de module mappé, accès autorisé');
    return true;
  }

  const hasAccess = checkPermission(module, 'read');
  console.log('[Permission] Accès à', module, ':', hasAccess);

  return hasAccess;
};

/**
 * Trouve la première route accessible pour l'utilisateur
 * Parcourt backoffice_permissions dans l'ordre de la réponse API
 */
export const getFirstAccessibleRoute = (account) => {
  const state = useAuthStore.getState();
  const permissions = state.user?.backoffice_permissions || {};

  // Debug: afficher les permissions disponibles
  console.log('[Permission] Recherche première route accessible');
  console.log('[Permission] Permissions:', permissions);

  // Créer un mapping inversé : module -> route
  const moduleToRoute = {};
  Object.entries(ROUTE_PERMISSION_MAP).forEach(([route, module]) => {
    if (!moduleToRoute[module]) {
      moduleToRoute[module] = route;
    }
  });

  // Parcourir les permissions dans l'ordre de la réponse API
  for (const [module, modulePermissions] of Object.entries(permissions)) {
    console.log('[Permission] Vérification module:', module, 'permissions:', modulePermissions);

    // Vérifier si ce module a une route associée et des permissions non vides avec 'read'
    if (moduleToRoute[module] &&
        isRouteAvailableForAccount(moduleToRoute[module], account) &&
        Array.isArray(modulePermissions) &&
        modulePermissions.length > 0 &&
        modulePermissions.includes('read')) {
      const route = moduleToRoute[module];
      console.log('[Permission] ✅ Première route accessible trouvée:', route, 'pour module:', module);
      return route;
    }
  }

  console.log('[Permission] ❌ Aucune route accessible, redirection vers /login');
  return '/login';
};

export const MODULES = {
  DASHBOARD: 'dashboard',
  CATALOGUE: 'catalogue',
  STOCK: 'stock',
  CLIENTS: 'clients',
  RECIPES: 'recipes',
  SETTINGS: 'settings',
  PROVIDERS: 'providers',
  CALENDAR: 'calendar',
  REPORTS: 'reports',
};

